export default {
  version: 'hotfix/IDCLOUD-1009-some-notifications-in-some',
  compilation: '235950'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1472
// module chunks = 22